import { useEffect, useRef } from 'react';

// Hides the Radix portal synchronously on resize so the browser never paints it at a stale position
const useDropdownDismissOnResize = (isOpen: boolean, onDismiss: () => void) => {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleResize = () => {
      if (!isOpen) return;

      const portalWrapper = contentRef.current
        ?.parentElement as HTMLElement | null;
      if (portalWrapper) portalWrapper.style.visibility = 'hidden';

      onDismiss();
    };

    window.addEventListener('resize', handleResize, { passive: true });
    return () => window.removeEventListener('resize', handleResize);
  }, [isOpen, onDismiss]);

  return { contentRef };
};

export default useDropdownDismissOnResize;
